module.exports = __webpack_public_path__ + "images/emoji/horse.67b0fa1f58da4744de4b.png";